// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__Ve4k_","col":"styles_col__3OrIy"};